// export const API_PAGOS = 'http://192.168.1.37:7000/api'
export const API_PAGOS = 'https://back.pagos.napnegocios.com/api'
// export const API_PAGOS = process.env.REACT_APP_API_PAGOS ?? 'http://192.168.1.22:7000/api'

// export const API_NAPCOBRANZAS = 'http://192.168.1.62:7001/api'
export const API_NAPCOBRANZAS = 'https://back-napcobranzas.napnegocios.com/api'
// export const API_NAPCOBRANZAS = process.env.REACT_APP_API_COBRANZAS ?? 'http://192.168.1.22:7001/api'
